import { useSelector } from "react-redux";

import en from "./en";
import fr from "./fr";

import { addLocale, locale } from 'primereact/api';
import moment from "moment";

// for primeReact
addLocale('fr', {
    firstDayOfWeek: 1,
    dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
    dayNamesShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
    dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
    monthNames: ['Janvier', 'Fevrier', 'Mars', 'Avril', 'May', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Decembre'],
    monthNamesShort: ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Août', 'Sep', 'Oct', 'Nov', 'Dec'],
    today: "Aujourd'hui",
    apply: 'Appliquer',
    clear: 'Vider',
    addRule: "Ajouter une condition",
    equals: "Est égal",
    contains: "Contient",
    notContains: "Ne contient pas",
    endsWith: "Se termine par",
    matchAll: "Correspondre à tout",
    matchAny: "Correspond à n'importe",
    emptyFilterMessage: "Pas de choix disponibles",
    emptyMessage: "Pas de résultats",
    startsWith: "Commence par",
    contains: "Contient",
    notContains: "Ne contient pas",
    endsWith: "Se termine par",
    equals: "Est égal à",
    notEquals: "N'est pas égal à",
    noFilter: "Pas de filtre",
    filter: "Filtre",
    dateIs: "Date est",
    dateIsNot: "Date n'est pas",
    dateBefore: "Date avant",
    dateAfter: "Date après",
    gte: "Supérieur ou égal à",
    gt: "Plus grand que",
    lte: "Inférieur ou égal à",
    lt: "Moins que",
    apply: "Appliquer",
    matchAll: "Correspondre à tous",
    matchAny: "Correspond à n'importe quel",
    addRule: "Ajouter une règle",
    removeRule: "Retirer la règle",
    accept: "Accepter",
    reject: "Rejeter",
    choose: "Choisir",
    upload: "Télécharger",
    cancel: "Annuler",
    close: "Fermer",
    pending: "En attente",
    chooseYear: "Choisir l'année",
    chooseMonth: "Choisir le mois",
    chooseDate: "Choisir la date",
    today: "Aujourd'hui",
    now: "Maintenant",
    country: "pays"
})

const DEFAULT_LANG = localStorage.getItem("lang") || "fr"
locale(DEFAULT_LANG)
moment.locale(DEFAULT_LANG)

let langs = {
    "en": en,
    "fr": fr
}
export default function Langs(props) {
    let lang = useSelector((state) => state.settings.lang)
    if (!lang) lang = localStorage.getItem("lang") || "fr"
    let Lang = langs[lang]
    let finalStr = props.str
    if (Lang && Lang[props.str])
        finalStr = Lang[props.str]
    if (props.params && Object.keys(props.params).length) {
        for (const key in props.params) {
            //console.log(key, props.params[key])
            let regex = new RegExp("%" + key + "%", "g");
            finalStr = finalStr.replace(regex, props.params[key])
        }
    }
    return finalStr
}

export function Localize(str, lang) {
    if (!lang) lang = localStorage.getItem("lang") || "fr"
    let Lang = langs[lang]
    let finalStr = str
    if (Lang && Lang[str])
        finalStr = Lang[str]
    return finalStr
}